var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.tooltip
        ? [
            _c(
              "v-tooltip",
              {
                attrs: { bottom: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              {
                                attrs: {
                                  text: _vm.flat,
                                  color: _vm.color,
                                  icon: _vm.iconOnly
                                }
                              },
                              on
                            ),
                            [
                              _vm.icon
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "pr-1",
                                      attrs: { small: _vm.smallIcon }
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.icon) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.iconOnly
                                ? _c("span", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.number) +
                                        "\n                "
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  892642792
                )
              },
              [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.number))])]
            )
          ]
        : [
            _c(
              "v-btn",
              {
                attrs: { text: _vm.flat, color: _vm.color, icon: _vm.iconOnly }
              },
              [
                _vm.icon
                  ? _c(
                      "v-icon",
                      { staticClass: "pr-1", attrs: { small: _vm.smallIcon } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.icon) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.iconOnly
                  ? _c("span", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.number) +
                          "\n            "
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }